import { TemplateNavHeaderBasicStyles } from "./NavHeader-Level0.styles"

const t = document.createElement('template')
t.innerHTML = `
<header class="ascend-header header-inner" role="banner">
  <nav class="main-nav" role="navigation" aria-label="Main Navigation">
    <!-- logo -->
    <slot name="logo"></slot>
    <!-- utility -->
    <slot name="utilityNavigation"></slot>
  </nav>
</header>
`
const TemplateNavHeaderBasic = t

class NavHeaderBasic extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderBasicStyles.content.cloneNode(true))
    shadow.appendChild(TemplateNavHeaderBasic.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderBasic connectedCallback')
  }
}


if (!customElements.get('ts-navheader-level0')) {
  customElements.define('ts-navheader-level0', NavHeaderBasic)
}
export { NavHeaderBasic }
